import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  screenings: [],
  currentScreening: null,
  loading: false,
  error: null,
  screeningIds: {
    htnScreenId: null,
    diabScreenId: null,
    oralScreeningId: null,
    breastScreeningId: null,
    cervicalScreeningId: null,
  },
  screeningData: {
    hypertension: null,
    diabetes: null,
    oral: null,
    breast: null,
    cervical: null,
  },
  viewMode: 'VIEW',
  openAccordionIndex: [],
};

const ncdSlice = createSlice({
  name: 'ncd',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setScreenings: (state, action) => {
      state.screenings = action.payload;
    },
    setCurrentScreening: (state, action) => {
      state.currentScreening = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    setScreeningIds: (state, action) => {
      state.screeningIds = { ...state.screeningIds, ...action.payload };
    },
    setScreeningData: (state, action) => {
      const { type, data } = action.payload;
      state.screeningData[type] = data;
    },
    setViewMode: (state, action) => {
      state.viewMode = action.payload;
      state.openAccordionIndex = [];
    },
    setOpenAccordionIndex: (state, action) => {
      state.openAccordionIndex = action.payload;
    },
    toggleAccordion: (state, action) => {
      const index = action.payload;
      const currentIndices = state.openAccordionIndex;
      state.openAccordionIndex = currentIndices.includes(index)
        ? currentIndices.filter(i => i !== index)
        : [...currentIndices, index];
    },
    clearScreeningData: (state, action) => {
      const key = action.payload;
      delete state.screeningData[key];
    }
  },
});

export const {
  setLoading,
  setScreenings,
  setCurrentScreening,
  setError,
  clearError,
  setScreeningIds,
  setScreeningData,
  setViewMode,
  setOpenAccordionIndex,
  toggleAccordion,
  clearScreeningData
} = ncdSlice.actions;
export default ncdSlice.reducer;